import { Controller } from "@hotwired/stimulus"

const PREFIX = "KLIENTR_"

export default class extends Controller {
  static values = { identityUrl: String, brandColor: String }
  static targets = [ "input", "messages" ]

  connect() {
    this.expanded = false
    this.unread = 0
    this.parentOrigin = this.referrerOrigin()
    this.onMessage = this.onMessage.bind(this)
    window.addEventListener("message", this.onMessage)
    this.observeMessages()
    this.post("READY", { color: this.brandColorValue })
  }

  disconnect() {
    window.removeEventListener("message", this.onMessage)
    this.observer?.disconnect()
  }

  close() {
    this.expanded = false
    this.post("RESIZE", { width: "72px", height: "72px", expanded: false })
  }

  onMessage(event) {
    if (event.source !== window.parent) return
    if (this.parentOrigin && event.origin !== this.parentOrigin) return
    if (!event.data || typeof event.data.type !== "string") return
    if (!event.data.type.startsWith(PREFIX)) return

    const type = event.data.type.slice(PREFIX.length)
    const payload = event.data.payload || {}

    if (type === "TOGGLE") {
      this.expanded = Boolean(payload.expanded)
      if (this.expanded) {
        this.unread = 0
        this.post("UNREAD_COUNT", { count: 0 })
        this.hasInputTarget && this.inputTarget.focus()
      }
      return
    }

    if (type === "SET_USER_DATA") this.setUserData(payload)
  }

  async setUserData(payload) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch(this.identityUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrf
      },
      body: JSON.stringify({
        name: payload.name,
        email: payload.email,
        hmac: payload.hmac
      })
    })
  }

  post(type, payload = {}) {
    window.parent.postMessage({ type: PREFIX + type, payload }, this.parentOrigin || "*")
  }

  referrerOrigin() {
    try {
      return document.referrer ? new URL(document.referrer).origin : null
    } catch (_error) {
      return null
    }
  }

  observeMessages() {
    if (!this.hasMessagesTarget) return

    this.observer = new MutationObserver((mutations) => {
      if (this.expanded) return

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.dataset.senderType === "User") {
            this.unread += 1
          }
        }
      }

      if (this.unread > 0) this.post("UNREAD_COUNT", { count: this.unread })
    })

    this.observer.observe(this.messagesTarget, { childList: true })
  }
}
